export const isValidLanguage = (language: string) => ['pt-BR', 'es-AR'].includes(language);

export default isValidLanguage;
